<div class="segmented-control" [class.disabled]="disabled" role="radiogroup">
  <button
    type="button"
    class="segment"
    *ngFor="let option of options"
    role="radio"
    [class.selected]="isSelected(option)"
    [class.stub]="option.stub"
    [attr.aria-checked]="isSelected(option)"
    [disabled]="disabled"
    [ngStyle]="segmentStyle(option)"
    (click)="select(option)">
    <i *ngIf="option.icon" [class]="option.icon" class="segment-icon"></i>
    <span class="segment-label">{{ option.label }}</span>
  </button>
</div>
